// extracted by mini-css-extract-plugin
module.exports = {"body":"BodyWrapper_body__3O7fq","content":"BodyWrapper_content__17kdV"};